import { CheckoutState } from '../../state';
import { areSyncExpressCheckoutEligibleCommonRulesMet } from './areSyncExpressCheckoutEligibleCommonRulesMet';

export const areExpressCheckoutConditionsReady = (state: CheckoutState) =>
    !areSyncExpressCheckoutEligibleCommonRulesMet(state) ||
    !!state.expressCheckout.expressCheckoutConditions;
